import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'
import classNames from 'classnames'

import CloudinaryVideo from './CloudinaryVideo'
import CloudinaryImage from './CloudinaryImage'

import s from './CloudinaryMedia.module.css'

function CloudinaryMedia({
  videos = [
    {
      url: '',
      type: '',
      params: '',
    },
  ],
  videoLoop = false,
  videoEnded = () => {},
  videoAutoplay = true,
  images = [
    {
      url: '',
      alt: '',
      params: '',
    },
  ],
  noLazy = false,
  className = '',
  altText = undefined,
}) {
  // Videos have no native lazy-load equivalent (unlike <img loading="lazy">),
  // so mounting the autoplaying <video> is deferred until it's near the
  // viewport.
  const { ref, inView } = useInView({ rootMargin: '1000px', triggerOnce: true })

  let media = null

  if (videos?.[0]?.url) {
    if (noLazy || inView) {
      media = (
        <CloudinaryVideo
          videos={videos}
          videoAutoplay={videoAutoplay}
          videoLoop={videoLoop}
          videoEnded={videoEnded}
        />
      )
    }
  } else if (images?.[0]?.url) {
    media = (
      <CloudinaryImage
        images={images}
        alt={altText}
        loading={noLazy ? 'eager' : 'lazy'}
      />
    )
  }

  return (
    <div ref={ref} className={classNames(s.container, className)}>
      {media}
    </div>
  )
}

CloudinaryMedia.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      type: PropTypes.string,
      params: PropTypes.string,
    })
  ),
  videoAutoplay: PropTypes.bool,
  videoLoop: PropTypes.bool,
  videoEnded: PropTypes.func,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      alt: PropTypes.string,
      params: PropTypes.string,
    })
  ),
  noLazy: PropTypes.bool,
  className: PropTypes.string,
  altText: PropTypes.string,
}

export default CloudinaryMedia
